import { getStoreId } from "$/hooks/use-store-information"
import { mechanicQueries } from "$/lib/queries/mechanic-queries"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import storeQueries from "$/lib/queries/store-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()

    if (storeId) {
      queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
      queryClient.prefetchQuery(storeQueries.detail(storeId))
      queryClient.prefetchQuery(mechanicQueries.list({ storeId }))
    }

    return {
      crumb: "alfred.settings.nav.profile.label",
    }
  },
})
